module.exports = __webpack_public_path__ + "static/media/Introduction.25255c99.png";